import { APIInterfaceWithActiveStatusI, buildRequest } from '.';

class organization implements APIInterfaceWithActiveStatusI {
  getAll = () => (
    buildRequest('GET', '/organizations')
  )

  register = (formData: any) => (
    buildRequest('POST', '/organizations', formData)
  )

  getOne = (targetName: string) => (
    buildRequest('GET', `/organizations/${targetName}`)
  )

  update = (targetName: string, formData: any) => (
    buildRequest('PUT', `/organizations/${targetName}`, formData)
  )

  delete = (targetName: string) => (
    buildRequest('DELETE', `/organizations/${targetName}`)
  )

  setActivateStatus = (targetName: string, newStatus: boolean) => (
    buildRequest('PUT', `/organizations/${targetName}/${newStatus ? 'activate' : 'deactivate'}`)
  )
}

export default organization;
